import _ from 'lodash'
import { mealListPromise } from 'api/Meal'
import MealListTable from './components/MealListTable'
import MealListToolbar from './components/MealListToolbar'
import { useLocation } from 'react-router-dom'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useEffectOnce } from 'react-use'

const MealList = props => {
  const ref = useRef()
  const location = useLocation()
  const [meals, setMeals] = useState({})
  const [params, setParams] = useState({ page: 1 })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    mealListPromise(too).then(resp => setMeals(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleSearchChange (payload) {
    handleParamsChange(payload, 500)
  }
  // end

  return (
    <div className={'root'}>
      <div className={'content'}>
        <MealListToolbar {...props} handleSearchChange={handleSearchChange} params={params} />
        <br />
        <MealListTable {...props} data={meals} page={params.page} onPageChange={handlePageChange} />
      </div>
    </div>
  )
}

export default MealList